export default __webpack_public_path__ + "26d370cfe8ed73f3b81c62f83b300afa.svg";